import { supabase } from '../lib/supabase';

const TABLE_NAME = 'clients';

// Get all clients
export const getClients = async () => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .order('name', { ascending: true });

  if (error) throw error;
  return data;
};

// Get single client by ID
export const getClient = async (id) => {
  if (id == null || id === '' || String(id) === 'null') {
    throw new Error('Invalid client ID');
  }
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('id', id)
    .single();

  if (error) throw error;
  return data;
};

// Create new client
export const createClient = async (clientData) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .insert([clientData])
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Update client
export const updateClient = async (id, clientData) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update(clientData)
    .eq('id', id)
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Delete client
export const deleteClient = async (id) => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('id', id);

  if (error) throw error;
};

// Get client sources (for dropdown)
export const getClientSources = async () => {
  try {
    const { data, error } = await supabase
      .from('client_sources')
      .select('*')
      .order('name', { ascending: true });

    if (error) throw error;
    return data || [];
  } catch (error) {
    console.error('Error fetching client sources:', error);
    return [];
  }
};

// Get filter options (unique values for dropdowns)
export const getFilterOptions = async () => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('city, state, zip');

  if (error) throw error;

  const cities = [...new Set(data.map(c => c.city).filter(Boolean))].sort();
  const states = [...new Set(data.map(c => c.state).filter(Boolean))].sort();
  const zips = [...new Set(data.map(c => c.zip).filter(Boolean))].sort();

  return { cities, states, zips };
};
